import axios from "axios";

//IMPORT API ROUTE URL
import { GET_LANGUAGES_BY_SEARCH_TEXT_ROUTE } from "./apiRoutes";

const getLanguagesBySearchText = (search_text, resourceSlug) => {
  var postData = new FormData();

  postData.append("search_text", search_text);
  postData.append("resource_slug", resourceSlug);

  return axios
    .post(GET_LANGUAGES_BY_SEARCH_TEXT_ROUTE, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getLanguagesBySearchText;
